import { Box, Text } from '@factorialco/deprecated-design-system'
import type { TeamDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { isActiveMember } from 'modules/teams/lib/isActiveMember'

import BlankState from './BlankState'
import Leader from './Leader'

interface Props {
  team: TeamDetailFragment
  readonly: boolean
  canSeeJobCatalog: boolean
  canSeeJobCatalogTree: boolean
  canSeeJobTitle: boolean
  hasLegacyJobCatalog: boolean
}

const Leaders = ({
  team,
  readonly,
  canSeeJobCatalog,
  canSeeJobCatalogTree,
  canSeeJobTitle,
  hasLegacyJobCatalog,
}: Props) => {
  const leaders = team.memberships.filter((m) => m.lead && isActiveMember(m))
  const hasLeaders = !!leaders.length
  return (
    <>
      <Box paddingBottom="s16">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t('teams.leaders.title')}
        </Text.Normal>
      </Box>
      {!hasLeaders && <BlankState team={team} readonly={readonly} />}
      {hasLeaders && (
        <Box flexDirection="row" flexWrap="wrap" justifyContent="spaceBetween">
          {leaders.map((leader) => (
            <Box key={leader.id} style={{ width: 'calc(50% - 8px)' }} paddingBottom="s16">
              <Leader
                canManageTeams={!readonly}
                membership={leader}
                teamId={team.id}
                canSeeJobCatalog={canSeeJobCatalog}
                canSeeJobCatalogTree={canSeeJobCatalogTree}
                canSeeJobTitle={canSeeJobTitle}
                hasLegacyJobCatalog={hasLegacyJobCatalog}
              />
            </Box>
          ))}
        </Box>
      )}
    </>
  )
}

export default Leaders
